
webpack.register(
    'react-src/root',
    function() {
        return import('react-src/root');
    },
    true
);
webpack.register(
    'react-modules/green-section/Video/LeftRailHeader/LeftRailHeaderModule',
    function() {
        return import('react-modules/green-section/Video/LeftRailHeader/LeftRailHeaderModule');
    },
    true
);